<form class="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto px-4 py-4">
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">Configuration</h3>
    <lib-signal-text-field label="Label" [formField]="configForm.label" />
    <lib-signal-text-field label="Placeholder" [formField]="configForm.placeholder" />

    <div class="flex flex-col gap-2">
      <div class="flex items-center justify-between gap-2">
        <span class="text-sm font-medium text-slate-800">Default value</span>
        @if (!isVariableLinked()) {
          <app-link-variable-button
            [valueTypes]="['text', 'number', 'date']"
            (variableSelected)="onVariableSelected($event)" />
        }
      </div>

      @if (linkedVariable(); as variable) {
        <div
          class="flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2">
          <app-svg-icon
            class="shrink-0 text-slate-500"
            src="assets/icons/link-variant.svg"
            [size]="16" />
          <div class="flex min-w-0 flex-1 flex-col gap-0.5">
            <span class="truncate font-mono text-xs text-slate-500">
              {{ variable.key }}
            </span>
            <span class="truncate text-sm font-medium text-slate-900">
              {{ variable.valueLabel || '—' }}
            </span>
          </div>
          <button
            type="button"
            class="inline-flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-lg border-0 bg-transparent text-slate-500 transition hover:bg-slate-100 hover:text-slate-800"
            title="Detach"
            aria-label="Detach"
            (click)="detachLinkedVariable()">
            <app-svg-icon src="assets/icons/link-variant-off.svg" [size]="16" />
          </button>
          <button
            type="button"
            class="inline-flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-lg border-0 bg-transparent text-slate-500 transition hover:bg-rose-50 hover:text-rose-600"
            title="Remove"
            aria-label="Remove"
            (click)="removeLinkedVariable()">
            <app-svg-icon src="assets/icons/delete-outline.svg" [size]="16" />
          </button>
        </div>
      } @else {
        <lib-signal-text-field
          label=""
          placeholder="Enter a default value"
          [formField]="configForm.defaultValue" />
      }
    </div>

    <lib-signal-text-field
      [label]="'Help text'"
      placeholder="Shown under the field"
      [formField]="configForm.helpText" />
  </section>
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">Validators</h3>
    <lib-signal-checkbox
      label="Required"
      hint="Respondent must fill this field"
      [formField]="configForm.required" />
    <div class="grid gap-3 sm:grid-cols-2">
      <lib-signal-number-field
        label="Min length"
        [numberMin]="0"
        [formField]="configForm.minLength" />
      <lib-signal-number-field
        label="Max length"
        [numberMin]="0"
        [formField]="configForm.maxLength" />
    </div>
    <lib-signal-text-field
      label="Pattern (regex)"
      placeholder="e.g. ^[A-Za-z]+$"
      [formField]="configForm.pattern" />
    <lib-signal-text-field
      label="Custom error message"
      placeholder="Shown when validation fails"
      [formField]="configForm.customMessage" />
  </section>
</form>
